import { render, staticRenderFns } from "./PrepayStep.vue?vue&type=template&id=f6a8d79e&"
import script from "./PrepayStep.vue?vue&type=script&lang=js&"
export * from "./PrepayStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports